import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Initialize Application Insights
const connectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;

let appInsights = null;

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      enableAutoRouteTracking: true, // Track route changes in SPA
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      disableFetchTracking: false, // Track fetch/XHR requests
      enableAjaxPerfTracking: true,
      maxAjaxCallsPerView: 500,
      autoTrackPageVisitTime: true,
    }
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView(); // Track initial page view

  console.log('✅ Application Insights initialized');
} else {
  console.warn('⚠️  Application Insights not configured (VITE_APPLICATIONINSIGHTS_CONNECTION_STRING not set)');
}

// Export tracking functions
export const trackEvent = (name, properties = {}) => {
  if (appInsights) {
    appInsights.trackEvent({ name }, properties);
  }
};

export const trackPageView = (name, properties = {}) => {
  if (appInsights) {
    appInsights.trackPageView({ name, properties });
  }
};

export const trackException = (error, properties = {}) => {
  if (appInsights) {
    appInsights.trackException({ exception: error, properties });
  }
};

export const trackMetric = (name, average, properties = {}) => {
  if (appInsights) {
    appInsights.trackMetric({ name, average }, properties);
  }
};

export const trackTrace = (message, properties = {}) => {
  if (appInsights) {
    appInsights.trackTrace({ message, properties });
  }
};

export const setAuthenticatedUserContext = (userId, accountId) => {
  if (appInsights) {
    appInsights.setAuthenticatedUserContext(userId, accountId);
  }
};

export const clearAuthenticatedUserContext = () => {
  if (appInsights) {
    appInsights.clearAuthenticatedUserContext();
  }
};

export default appInsights;
